// extracted by mini-css-extract-plugin
export default {"loader_container":"Routes_loader_container__chX+6","loader":"Routes_loader__ldlIx"};